import React from 'react'

import { faMap } from '@fortawesome/pro-regular-svg-icons'
import { Button } from 'antd'
import { Modal } from 'govwell-ui'

import EntityVersionSearchMap, {
  EntityVersionSearchMapProps,
} from 'src/components/Selects/EntityVersionSearch/EntityVersionSearchMap'
import { getSearchEntityLayersCaption } from 'src/utils/gis'

type Props = EntityVersionSearchMapProps & {
  onClose: () => void
}

const EntityVersionSearchMapModal = (props: Props) => {
  const { onClose, ...entityVersionSearchMapProps } = props
  const { entityLayers } = entityVersionSearchMapProps

  const count = Array.isArray(entityVersionSearchMapProps.value)
    ? entityVersionSearchMapProps.value?.length
    : entityVersionSearchMapProps.value
      ? 1
      : 0

  const buttonText = count > 0 ? `Done (${count} selected)` : 'Done'

  const modalHeader = getSearchEntityLayersCaption(entityLayers)
  return (
    <Modal width="70vw" className="min-w-[350px]" onClose={onClose}>
      <Modal.Header icon={faMap}>{modalHeader}</Modal.Header>
      <Modal.Content>
        <EntityVersionSearchMap {...entityVersionSearchMapProps} />
      </Modal.Content>
      <Modal.Footer>
        <Button type="primary" onClick={onClose}>
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(EntityVersionSearchMapModal)
